export enum EquipmentStatusOptions {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}
